import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';

export default function NotFound() {
  return (
    <div className="bg-sand-50 min-h-screen flex items-center justify-center px-4">
      <div className="text-center max-w-sm">
        <p className="font-heading text-7xl font-bold text-terra-400/30 mb-4">404</p>
        <h1 className="font-heading text-2xl font-semibold text-ink-900 mb-2">Page not found</h1>
        <p className="text-sm text-ink-400 mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/">
          <Button variant="primary">Go Home</Button>
        </Link>
      </div>
    </div>
  );
}
